<div class="snackbar-container" popover="manual" #snackbarContainer>
  @if (snackbars()?.length) {
    <twc-snackbar [snackbarData]="snackbars()[0]" />
    @for (snackbar of snackbars().slice(1).reverse(); track snackbar) {
      <twc-snackbar [snackbarData]="snackbar" />
    }
  }
</div>
